import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import SearchBar from '../../searchbar/SearchBar';
import FieldSet from '../../fieldset/FieldSet';
import Grid from '../../grid/Grid';
import SDKService from '../../../service/SdkService';
import SDKPaymentModal from './SDKPaymentModal';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../modules/Constants';

class SDKView extends React.Component {
  constructor(props) {
    super(props);

    this.comboFields = [
      {
        value: 'customerId',
        display: 'Customer Id',
      },
      {
        value: 'transactionId',
        display: 'Transaction Id',
      },
      {
        value: 'email',
        display: 'Customer Email',
      },
      {
        value: 'externalId',
        display: 'External Id',
      },
    ];

    this.allowedPaymentKeys = [
      'id',
      'externalId',
      'label',
      'description',
    ];

    this.state = {
      grid: null,
      isReady: false,
      selectedPaymentRow: null,
      paymentRows: [],
    };
  }

  onPaymentRowSelect(selectedRow) {
    const { paymentRows, } = this.state;

    const payment = paymentRows.find((row) => {
      const { raw, } = row;
      return raw.id === selectedRow.id;
    });

    this.setState({
      selectedPaymentRow: payment.raw,
    });
  }

  getPayments(criteria, onCompletion) {
    this.reset();

    SDKService.getSDKPaymentsBySearch(criteria)
      .then((response) => {
        const { payments, } = response.data;
        const headers = this.allowedPaymentKeys.map(header => ({
          value: header,
          display: _.startCase(header),
        }));
        headers.push({ value: 'amount', display: 'Amount', });
        const rows = [];

        payments.forEach((payment) => {
          const filtered = {
            ..._.pick(payment, this.allowedPaymentKeys),
            amount: _.get(payment, 'total.amount'),
          };

          rows.push({
            value: Object.values(filtered),
            raw: payment,
          });
        });

        this.setState({
          grid: (
            <FieldSet title="SDK Payments">
              <Grid
                headers={headers}
                rows={rows}
                onRowSelect={row => this.onPaymentRowSelect(row)}
                onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
              />
            </FieldSet>
          ),
          paymentRows: rows,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        onCompletion();
        this.setState({ isReady: true, });
      });
  }

  formatPaymentDetails = (payment) => {
    if (!payment) {
      return null;
    }

    return (
      <div className="container">
        <hr />
        <div className="row">
          <div className="p-2">
            <SDKPaymentModal payment={payment} />
          </div>
        </div>
      </div>
    );
  };

  formatSelectedPaymentDisplay(payment) {
    if (!payment) {
      return null;
    }
    return <p>{`Selected payment ID: ${payment.id}`}</p>;
  }

  searchOnClick(event) {
    const { combo = {}, search = {}, } = event;
    const { serviceOfferingId, } = this.props;
    const criteria = {};
    criteria[combo.value] = search.value;
    criteria.serviceOfferingId = serviceOfferingId;
    this.getPayments(criteria, event.kill);
  }

  reset() {
    this.setState({
      grid: null,
      isReady: false,
      selectedPaymentRow: null,
      paymentRows: [],
    });
  }

  showPayments() {
    const {
      isReady, grid, selectedPaymentRow,
    } = this.state;

    if (isReady) {
      return (
        <>
          {grid}
          {this.formatSelectedPaymentDisplay(selectedPaymentRow)}
          {this.formatPaymentDetails(selectedPaymentRow)}
        </>
      );
    }

    return null;
  }

  render() {
    return (
      <div className="container">
        <SearchBar comboFields={this.comboFields} onClick={event => this.searchOnClick(event)} />
        <div className="row">
          <div className="col-12">
            {this.showPayments()}
          </div>
        </div>
      </div>
    );
  }
}

SDKView.propTypes = {
  serviceOfferingId: PropTypes.string.isRequired,
};

export default SDKView;
